
import * as ReactGA from "react-ga";

export function initializeGA() {
  ReactGA.initialize("UA-105682562-1");
  ReactGA.pageview(window.location.pathname + window.location.search);
}

export function logEvent(category, action, label) {
  ReactGA.event({
    category,
    action,
    label: String(label),
  });
}
